import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const localePermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    {
      actions: [Actions.read, Actions.create, Actions.update],
      subject: Models.Locale,
    },
    {
      actions: [Actions.read],
      subject: Models.Locales,
    },
  ],

  [UserRole.Operator]: [
    {
      actions: [Actions.read],
      subject: Models.Locale,
    },
    {
      actions: [Actions.read],
      subject: Models.Locales,
    },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    {
      actions: [Actions.read],
      subject: Models.Locale,
    },
    {
      actions: [Actions.read],
      subject: Models.Locales,
    },
  ],

  [UserRole.DeviceOperator]: [
    {
      actions: [Actions.read],
      subject: Models.Locale,
    },
    {
      actions: [Actions.read],
      subject: Models.Locales,
    },
  ],

  [UserRole.OperatorReadAccess]: [
    {
      actions: [Actions.read],
      subject: Models.Locale,
    },
    {
      actions: [Actions.read],
      subject: Models.Locales,
    },
  ],

  [UserRole.TtmOperator]: [
    {
      actions: [Actions.read],
      subject: Models.Locale,
    },
    {
      actions: [Actions.read],
      subject: Models.Locales,
    },
  ],

  [UserRole.DeviceQualityOperator]: [
    {
      actions: [Actions.read],
      subject: Models.Locale,
    },
    {
      actions: [Actions.read],
      subject: Models.Locales,
    },
  ],
};
